import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import WhatsAppBannerIcon from "../../../../../assets/svg-fc/WhatsAppBannerIcon";
import palette from "../../../../../theme/palette";
import { VendorEventResponseStatusesEnum, iEventType } from "../../../../../types/eventTypes";
import { formatDate, getStringsFirstLetter } from "../../../../../utils/commonUtils";
import { isObjectEmpty } from "../../../../../helpers/common";
import DeclineCorporateEventIcon from "../../../../../assets/svg-fc/b2b/DeclineCorporateEventIcon";
import "./ChatHeader.scss";
import ChatBackIcon from "../../../../../assets/svg-fc/ChatBackIcon";

interface ChatHeaderProps {
	vendorName: string;
	vendorLogo: string;
	initials: string;
	logoBackgroundColor?: string;
	logoTextColor?: string;
	whatsAppIconVisible: boolean;
	vendorEventStatus: VendorEventResponseStatusesEnum;
	eventDetail: iEventType;
	showBackButton?: boolean;
	isMobile?: boolean;
	onSocialClick?: () => void;
	onCancelEventClick?: () => void;
	onBackClick?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
	vendorName,
	vendorLogo,
	initials,
	logoBackgroundColor,
	logoTextColor,
	onSocialClick,
	onBackClick,
	onCancelEventClick,
	whatsAppIconVisible,
	vendorEventStatus,
	eventDetail,
	showBackButton = true,
	isMobile = false,
}) => {
	const activeEventStatus = [
		VendorEventResponseStatusesEnum.AssignedByAdmin,
		VendorEventResponseStatusesEnum.AvailableForBidding,
		VendorEventResponseStatusesEnum.Bidding,
	];
	const isRequest = !!eventDetail.request;

	const customerDetails = useMemo(() => {
		if (isObjectEmpty(eventDetail))
			return {
				customerFirstLastName: "",
				eventName: "",
				eventDate: "",
				customerName: "",
			};
		return {
			customerFirstLastName: isRequest
				? getStringsFirstLetter(
						eventDetail.request?.customerName.split(" ")[0],
						eventDetail.request?.customerName.split(" ")[1],
					)
				: getStringsFirstLetter(eventDetail.customer?.firstName, eventDetail.customer?.lastName),
			eventName: isRequest ? eventDetail.request?.name || "" : eventDetail?.name,
			eventDate: formatDate(eventDetail.eventDate, false),
			customerName: isRequest
				? eventDetail.request?.customerName || ""
				: `${eventDetail.customer?.firstName} ${eventDetail.customer?.lastName}`,
		};
	}, [eventDetail]);

	return (
		<Box id="chatHeaderB2C" className="chatHeaderB2C">
			<Box className="chatHeaderContent">
				<Box className="chatHeaderLeft">
					<Box className="chatHeaderAvatar">
						{showBackButton && (
							<Box className="chatHeaderBackIcon" onClick={onBackClick}>
								<ChatBackIcon />
							</Box>
						)}
						<Box className="avatarBackground">
							<Typography className="avatarText">{customerDetails.customerFirstLastName}</Typography>
						</Box>
						<Box className="eventName">
							<strong>{customerDetails.eventName}</strong>
							<Typography>
								<span>{customerDetails.eventDate} &nbsp;| &nbsp; {customerDetails.customerName}</span> 
							</Typography>
						</Box>
					</Box>
				</Box>
				<Box className="chatHeaderRight">
					{whatsAppIconVisible && (
						<Box className="iconButton" onClick={onSocialClick}>
							<WhatsAppBannerIcon size="24" fill={palette.grey[1000]} />
						</Box>
					)}
					{activeEventStatus.includes(vendorEventStatus) && isMobile && (
						<Box className="iconButton" onClick={onCancelEventClick}>
							<DeclineCorporateEventIcon />
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default ChatHeader;
